import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-labelview',
  templateUrl: './label-view.component.html',
  styleUrls: ['./label-view.component.scss'],
})
export class LabelViewComponent implements OnInit {
  blobUrl;
  labelName = '';
  page = 1;
  zoom = 1.0;
  zoomScale = 'page-width';
  pdf: any;
  stickToPage = false;
  showAll = true;
  fitToPage = false;
  renderImage: SafeResourceUrl = '';
  renderData: { label?: string; labelName?: string; format?: string } = {};

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: {
      label: string;
      labelName: string;
      format: string;
    }
  ) {
    this.renderData = this.data;
  }

  ngOnInit(): void {
    if (this.renderData?.label) {
      this.loadLabelType(this.renderData, this.renderData?.format);
    }
  }

  loadLabelType(data, format) {
    this.labelName = data?.labelName;
    const formatConfigs = {
      default: () => this.viewImageLabel(format, data?.label),
      pdf: () => this.viewLabel(data?.label),
    };
    return (formatConfigs[format.toLowerCase()] || formatConfigs.default)();
  }

  viewLabel(label) {
    this.blobUrl = '';
    const byteCharacters = atob(label);
    // let type = 'text/plain';
    if (byteCharacters.indexOf('%PDF') > -1) {
      // type = 'application/pdf';
    }
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    this.blobUrl = URL.createObjectURL(blob);
  }

  printLabel() {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = this.blobUrl;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }

  downloadLabel(format) {
    const link = document.createElement('a');
    link.href = this.blobUrl;
    link.download = `${this.labelName}.${format}`;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }

  viewImageLabel(format, base64String) {
    this.blobUrl = this.renderImage = `data:image/${format};base64,${base64String}`;
  }
}
